import { SaleDocumentKind } from "@skylab-shared/dataModel";
import { Type } from "class-transformer";
import { OrderAddressDTO } from "./order-address.dto";

export class OrderDocumentDTO {
	documentType: SaleDocumentKind;
	name: string;
	taxIdentification: string;
	@Type(() => OrderAddressDTO) public address: OrderAddressDTO | null;
}